import { render } from "./UpsellModal.vue?vue&type=template&id=58eafa84&scoped=true"
import script from "./UpsellModal.vue?vue&type=script&lang=js"
export * from "./UpsellModal.vue?vue&type=script&lang=js"

import "./UpsellModal.vue?vue&type=style&index=0&id=58eafa84&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eafa84"]])

export default __exports__